var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvironmentalLaws(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 47.75,
    fill: "#FEFEFE",
    stroke: "#1C1C1C",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4118 67.8776V63.2794C25.4118 63.2794 36.7059 58.6811 48 58.6811C59.2941 58.6811 70.5882 63.2794 70.5882 63.2794V67.8776H25.4118ZM46.4188 38.2187C43.7082 29.2521 29.9294 31.3213 29.9294 31.3213C29.9294 31.3213 30.3812 49.2546 43.2565 46.4956C42.3529 39.8281 38.9647 37.9888 38.9647 37.9888C45.2894 37.9888 45.7412 45.8059 45.7412 45.8059V56.3819H50.2588V46.7255C50.2588 46.7255 50.2588 37.7589 57.0353 35.4598C57.0353 35.4598 52.5176 42.3572 52.5176 46.9555C68.3294 48.5649 68.3294 26.4931 68.3294 26.4931C68.3294 26.4931 48.2259 24.194 46.4188 38.2187Z",
    fill: "#1C1C1C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmentalLaws);
export default __webpack_public_path__ + "static/media/EnvironmentalLaws.9c24c53331c1a0c90ca94ca88e6248fb.svg";
export { ForwardRef as ReactComponent };